import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: 64,
    height: 32,
    padding: 0,
    margin: 0,

    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',

      '&.Mui-checked': {
        transform: 'translateX(32px)',
        color: theme.primary.p2,

        '& + .MuiSwitch-track': {
          backgroundColor: theme.accent.a1,
          opacity: 1,
          border: 0,
        },
      },

      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: theme.accent.a1,
        border: `6px solid ${theme.primary.p2}`,
      },

      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.secondary.s1,
      },

      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.secondary.s2,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 28,
      height: 28,
    },
    '& .MuiSwitch-track': {
      borderRadius: 32 / 2,
      backgroundColor: theme.accent.a4,
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),

      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: 12,
        color: theme.primary.p2,
      },
      '&::before': {
        content: '"ON"',
        left: 8,
      },
      '&::after': {
        content: '"OFF"',
        right: 7,
      },
    },
  },
}));

export default useStyles;
